import PC from '@/pages/login'
import Mobile from '@/mobile-pages/login'
import useIsMobile from '@/hooks/useIsMobile'

const Login = () => {
  return useIsMobile() ? <Mobile /> : <PC />
}

export default Login
